<template>
  <BasicSkeleton :showPlaceholder="pending">
    <div
      class="c-article-exp-price-basic exp-price"
      v-if="!pending && localprice?.bruttoPrice !== undefined"
    >
      <div
        v-if="!pending"
        class="beforeprice"
      >
        <slot
          name="beforePrice"
          :finalPrice="localprice"
        ></slot>
      </div>
      <div
        class="theme-price"
        v-if="!pending && localprice?.bruttoPrice !== undefined"
      >
        <div
          class="formerPrice-comp col-span-2"
          :class="formerPriceClass + (addsReserveSpace ? ' formerprice-placeholder' : '')"
        >
          <template v-if="localprice.itemOnDisplay">
            <ArticleExhibitFlag
              :exhibitInfo="localprice.itemOnDisplay"
              :withInfo="withExhibitInfo"
            />
          </template>
          <template v-else>
            <div
              v-if="addsReserveSpace"
              class="exhibit-placeholder flex justify-center"
            ></div>
          </template>
        </div>
        <div
          v-if="includeActiveBundle && !activeBundlePrice"
          class="formerPrice-comp"
          :class="formerPriceClass + (addsReserveSpace ? ' formerprice-placeholder' : '')"
        >
          <template
            v-if="
              formerPriceDifferenceText != null
              && localarticle?.formerPriceState !== ''
              && localarticle?.formerPriceState !== null
              && enableUVPLabel
              && formerPriceDifferenceText?.length > 2
              && localarticle?.formerBruttoPrice > localprice.bruttoPrice
            "
          >
            <div
              class="flex gap-2"
              :class="addsReserveSpace ? 'justify-center exhibit-placeholder' : 'items-center'"
            >
              <div class="formerPrice">
                <div class="relative">
                  <div class="line-through"></div>
                  &nbsp;{{ localarticle?.formerPriceState }}&nbsp;{{ localarticle?.formerBruttoPrice }}€
                </div>
              </div>

              <div
                class="sales-label"
                v-if="enableUVPLabel && enableUVPFlag"
              >
                <div
                  v-if="formerPriceDifferenceText !== undefined && formerPriceDifferenceText !== null"
                  class="formerPricePercent"
                >
                  {{ formerPriceDifferenceText }}
                </div>
              </div>
              <template v-if="enableUVPFlyOut == true">
                <div class="uvp-info relative flex">
                  <img
                    class="w-5"
                    alt="Unverbindliche Preis Empfehlung"
                    src="~/assets/mediums/Icons/circle-info-light.svg"
                    @mouseleave="$device.isDesktop ? (showUvpTextField = false) : false"
                    @mouseover="$device.isDesktop ? (showUvpTextField = true) : false"
                    @click.prevent="showUvpTextField = !showUvpTextField"
                  />
                  <FlyOutsUVP v-if="showUvpTextField" />
                </div>
              </template>
            </div>
          </template>
        </div>
        <template v-if="proms?.directDiscount !== undefined && proms?.directDiscount !== 0">
          <div class="flex gap-2">
            <span class="our-price-label text-xs mt-0.5">= Unser Preis</span>
            <div class="our-price-value flex flex-col text-xl text-tertiary-contrast bg-tertiary px-4 rounded-xl">
              <ArticlePubDataWrapper
                class="our-price exp_price"
                :createdOn="localprice?.createdOn"
                :lastUpdated="localprice?.lastUpdated"
                :cacheLevel="localprice?.cacheLevel"
                :pubSource="localprice?.pubSource"
              >
                {{
                  (localprice.bruttoPrice % 1 === 0
                    ? localprice.bruttoPrice + '.-'
                    : parseFloat(localprice.bruttoPrice).toFixed(2))
                  + (localprice.monthly ? ' pro Monat' : isWarranty ? ' einmalig' : '')
                }}
              </ArticlePubDataWrapper>
            </div>
          </div>
          <div class="flex gap-1 mt-1">
            <span class="immediate-discount-label text-xs mt-0.5">- Sofortrabatt</span>
            <div class="immediate-discount-value flex flex-col text-xl text-white px-4 rounded-xl">
              <span class="immediate-discount exp_price">
                -
                {{
                  (proms.directDiscount * -1) % 1 === 0
                    ? (proms.directDiscount * -1).toFixed(0) + '.-'
                    : (proms.directDiscount * -1).toFixed(2)
                }}
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <div :class="addsReserveSpace && !isWarranty ? 'promted-placeholder' : ''" />
        </template>
        <div class="wrapper-gross-delivery">
          <div>
            <div
              class="display-price-label text-tertiary"
              :class="displayPriceDesignClasses"
            >
              <template v-if="proms?.directDiscount !== undefined && proms?.directDiscount !== 0">
                <span class="exp_price">
                  {{ proms.checkoutPrice % 1 === 0 ? proms.checkoutPrice + '.-' : proms.checkoutPrice.toFixed(2) }}
                </span>
              </template>
              <template v-else>
                <ArticlePubDataWrapper
                  class="exp_price text-left"
                  :createdOn="localprice?.createdOn"
                  :lastUpdated="localprice?.lastUpdated"
                  :cacheLevel="localprice?.cacheLevel"
                  :pubSource="localprice?.pubSource"
                >
                  {{
                    (checkoutPrice % 1 === 0 ? checkoutPrice + '.-' : parseFloat(checkoutPrice).toFixed(2))
                    + (localprice.monthly ? ' pro Monat' : isWarranty ? ' einmalig' : '')
                  }}
                </ArticlePubDataWrapper>
              </template>
            </div>
            <template v-if="pprice?.basicPrice?.gross && pprice?.basicPriceUnit">
              <div class="text-xs text-paragraph-light">
                ({{
                  (pprice.basicPrice?.gross % 1 === 0
                    ? pprice.basicPrice?.gross + '.-'
                    : parseFloat(pprice.basicPrice?.gross).toFixed(2))
                  + ('€ pro ' + pprice.basicPriceUnit)
                }})
              </div>
            </template>
            <template
              v-if="
                currentStore?.storeId == '2879130'
                && useRoute().fullPath.includes(localarticle?.webcode)
                && showOnlinePriceInfo
              "
            >
              <span class="text-sm font-bold">Onlinepreis </span>
            </template>
          </div>
          <ArticleDeliveryInfo
            :enableDeliveryModal="enableDeliveryModal"
            :showShipmentInformation="showShipmentInformation"
            :pprice="pprice"
            :deliveryInfoClass="deliveryInfoClass"
            :showShippingEstimate="showShippingEstimate"
            :addsReserveSpace="addsReserveSpace"
            :localprice="localprice"
            :lineBreakDeliveryInfo="lineBreakDeliveryInfo"
            :shipmentBruttoPrice="shippingCost"
            :hide-shipment-price="hideShipmentPrice"
          :several-shipment-options="hasSeveralShipmentOptions"
          />
        </div>
        <template
          v-if="
            showCalculator && featureStatePaypal == true && featureValuePaypal?.enabled == true && checkOnlineSalable()
          "
        >
          <BasicBtErrorBoundary>
            <ExternalPaypalCalculator
              :price="localprice"
              :article-id="localarticle?.articleId"
              page-type="product-listing"
            />
          </BasicBtErrorBoundary>
        </template>
        <template
          v-if="
            showCalculator && featureStateKlarna == true && featureValueKlarna?.enabled == true && checkOnlineSalable()
          "
        >
          <BasicBtErrorBoundary>
            <ExternalKlarnaCalculator
              v-if="localprice"
              :price="localprice"
              type="credit-promotion-auto-size"
              class="min-h-10"
            />
          </BasicBtErrorBoundary>
        </template>
      </div>

      <div
        v-if="!pending"
        class="afterprice"
      >
        <slot
          name="afterPrice"
          :finalPrice="localprice"
        ></slot>
      </div>
    </div>
    <template #placeholder>
      <SkeletonPrice />
    </template>
  </BasicSkeleton>
</template>

<script setup lang="ts">
import type { FullPrice, NeoService } from '@expert/types';
import { getPrice } from '~/composables/ExpApi/expPrice';
import { usePDSActiveBundlePrice } from '~/composables/states';

const activeBundlePrice = usePDSActiveBundlePrice();
interface Props {
  localarticle: object;
  pprice: FullPrice;
  withExhibitInfo?: boolean;
  lineBreakDeliveryInfo?: boolean;
  showEEL?: boolean;
  addsReserveSpace?: boolean;
  displayPriceDesignClasses?: string;
  deliveryInfoClass?: string;
  formerPriceClass?: string;
  popOverClass?: string;
  showShipmentInformation?: boolean;
  hideShipmentPrice?: boolean;
  isWarranty?: boolean;
  enableDeliveryModal?: boolean;
  enableUVPLabel?: boolean;
  enableUVPFlyOut?: boolean;
  enableUVPFlag?: boolean;
  uvpTextField?: boolean;
  showOnlinePriceInfo?: boolean;
  showDataFile?: boolean;
  showShippingEstimate?: boolean;
  discountedPrice?: number;
  showCalculator?: boolean;
  includeActiveBundle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  lineBreakDeliveryInfo: false,
  showEEL: false,
  displayPriceDesignClasses: 'text-5xl relative flex gap-4',
  deliveryInfoClass: '',
  formerPriceClass: 'flex gap-2 flex-wrap relative items-center',
  popOverClass: 'w-[250px]',
  showShipmentInformation: true,
  hideShipmentPrice: false,
  isWarranty: false,
  enableDeliveryModal: true,
  enableUVPLabel: true,
  enableUVPFlyOut: true,
  enableUVPFlag: true,
  uvpTextField: false,
  showOnlinePriceInfo: true,
  showDataFile: false,
  showShippingEstimate: false,
  withExhibitInfo: true,
  discountedPrice: 0,
  showCalculator: false,
  includeActiveBundle: false,
});

const localprice: Ref<FullPrice> = ref(props?.pprice);
const checkoutPrice = computed(() => {
  let currentPrice = localprice?.value?.bruttoPrice;
  if (props.discountedPrice !== undefined && props.discountedPrice !== 0) {
    currentPrice = props.discountedPrice;
  }
  if (props.includeActiveBundle && activeBundlePrice && activeBundlePrice.value !== 0) {
    currentPrice = currentPrice + activeBundlePrice.value;
  }
  return currentPrice;
});

const proms = ref();
watch(
  () => props?.pprice,
  () => {
    localprice.value = props?.pprice;
    proms.value = getArticlePromotionPrice(props?.localarticle?.articleId, localprice?.value);
  },
  { immediate: true },
);
const pending = ref(true);

const showUvpTextField = ref(false);

const minPercentDifference = 10;
const maxPercentDifference = 70;
const minPriceForPercentage = 50;
const minAbsolutDifference = 5;
if (props.pprice === null || props.pprice === undefined) {
  console.debug('fetching price because none was given');
  const { pending: checkPending, data: neuerPreis } = await getPrice(
    props?.localarticle?.webcode ?? props?.localarticle?.articleId,
    useCurrentStore(),
    false,
    false,
  );
  pending.value = false;
  if (neuerPreis.value) localprice.value = neuerPreis.value?.price;
} else {
  pending.value = false;
}

const formerPriceDifferenceText = computed(() => {
  const calculation = 100 - (localprice?.value?.bruttoPrice / props.localarticle?.formerBruttoPrice) * 100;
  const result = Math.floor(calculation);
  if (localprice?.value?.bruttoPrice >= minPriceForPercentage) {
    if (calculation > minPercentDifference && calculation < maxPercentDifference) return '-' + result + '%';
  } else {
    if (
      props.localarticle?.formerBruttoPrice - localprice?.value?.bruttoPrice >= minAbsolutDifference
      && calculation < maxPercentDifference
    )
      return '-' + result + '%';
  }
  return undefined;
});

const checkOnlineSalable = () => {
  const onlineAvailabilityArray = ['AVAILABLE', 'PREORDER'];
  return onlineAvailabilityArray.includes(localprice.value?.onlineAvailability);
};

const hasSeveralShipmentOptions = computed(() => {
  const shipments = localprice.value?.shipmentArray;
  const deliveryInfos = localprice.value?.availableServices?.find((service: NeoService) => service.label === 'Lieferung');
  return (shipments?.length || 0) + (deliveryInfos?.price?.gross ? 1:0) > 1
})

const shippingCost = computed(() => {
  const shipments = localprice.value?.shipmentArray;
  const deliveryInfos = localprice.value?.availableServices?.find((service: NeoService) => service.label === 'Lieferung');
  if (!shipments?.length) return null;

  const prices = shipments
    .map(shipment => shipment.shipmentBruttoPrice)
    .filter(price => price != null);
  const minPrice = prices.length ? Math.min(...prices) : null;
  const reservationPrice = deliveryInfos?.price?.gross ? deliveryInfos.price.gross.toFixed(2) : null
  return localprice?.value?.shipmentArray[0]?.shipmentBruttoPrice == 0 ? localprice.value?.shipmentArray[0].shipmentBruttoPrice : (minPrice && reservationPrice ? Math.min(minPrice, reservationPrice) : minPrice || reservationPrice);
});

const currentStore = useCurrentStore();
const featureStateKlarna = useFeatureState('ES-6966_Klarna');
const featureValueKlarna = useFeatureValue('ES-6966_Klarna');
const featureStatePaypal = useFeatureState('ES-6966_Paypal');
const featureValuePaypal = useFeatureValue('ES-6966_Paypal');
</script>
<style lang="postcss">
.exhibit-placeholder {
    @apply h-5;
}
.formerprice-placeholder {
    @apply h-7;
}
.design-line {
    .exhibit-placeholder {
        @apply h-auto lg:h-5;
    }
    .formerprice-placeholder {
        @apply h-auto lg:h-8;
    }
}
</style>
<style lang="postcss" scoped>
.formerPricePercent {
  @apply bg-primary text-primary-contrast px-2 text-base rounded-full;
}

.our-price {
  line-height: 1em;
}

.our-price.exp_price,
.immediate-discount.exp_price {
  letter-spacing: normal;
}

.immediate-discount-value {
  @apply bg-primary;
}

.promted-placeholder {
  height: 2.75rem;
}
</style>
